module.exports = __webpack_public_path__ + "static/media/chess-king.bf9b57d9.svg";